import MeasurementsSort from './enums/MeasurementsSort';
import { ChartHeight } from './enums/ChartHeight';
import FloorPlanEntities from './enums/FloorPlanEntities';
import FloorPlanDisplayModes from './enums/FloorPlanDisplayModes';
export var UserSettingsValues;
(function (UserSettingsValues) {
    UserSettingsValues["UNASSIGNED_GROUP_ID"] = "U";
    UserSettingsValues["ALL_GROUP_ID"] = "A";
})(UserSettingsValues || (UserSettingsValues = {}));
export class UserSettings {
    language = 'sk';
    datetime;
    events = {
        units: {
            0: 'Default',
            1: 'Default',
            2: 'Default',
            3: 'Default',
            4: 'Default',
            5: 'Default',
            6: 'Default',
            7: 'Default',
            8: 'Default',
            9: 'Default',
            12: 'Default'
        }
    };
    notifications = { pause: { msgDismissedAt: '0', until: '0' } };
    pinnedMenuItems = JSON.stringify([]);
    preferences = {
        favoriteDepartmentId: null,
        annotateLoggerStateChange: 'true',
        measurementSort: MeasurementsSort.TIME,
        chartHeights: {
            main: ChartHeight.SMALL,
            gas: ChartHeight.SMALL,
            waterlevel: ChartHeight.SMALL,
            wind: ChartHeight.SMALL,
            noise: ChartHeight.SMALL
        },
        statusPageRefreshEnabled: 'true',
        floorPlanSettings: {
            displayMode: FloorPlanDisplayModes.MEASURED,
            eventType: '1',
            selectedHardware: JSON.stringify([
                FloorPlanEntities.SOURCE,
                FloorPlanEntities.GATEWAY,
                FloorPlanEntities.EQUIPMENT
            ])
        },
        csvFormatLocale: null,
        dashboardLayout: null
    };
    userRating = { isSubmitted: 'false', firstLoginTimestamp: null, lastShownTimestamp: null };
    rawSettings = null;
    customSettings = [];
    constructor() { }
    static fromApi(data) {
        return UserSettings.define(data);
    }
    static define(data) {
        let userSettings = new UserSettings();
        userSettings.rawSettings = data;
        userSettings.language = data?.language || userSettings.language;
        userSettings.datetime = UserSettings.parseDatetime(data?.datetime);
        userSettings.pinnedMenuItems = data?.pinnedMenuItems || userSettings.pinnedMenuItems;
        userSettings.preferences.favoriteDepartmentId =
            data?.preferences?.favoriteDepartmentId || userSettings.preferences.favoriteDepartmentId;
        userSettings.preferences.annotateLoggerStateChange =
            data?.preferences?.annotateLoggerStateChange || userSettings.preferences.annotateLoggerStateChange;
        userSettings.preferences.measurementSort =
            data?.preferences?.measurementSort || userSettings.preferences.measurementSort;
        userSettings.preferences.chartHeights.main =
            data?.preferences?.chartHeights?.main || userSettings.preferences.chartHeights.main;
        userSettings.preferences.chartHeights.gas =
            data?.preferences?.chartHeights?.gas || userSettings.preferences.chartHeights.gas;
        userSettings.preferences.chartHeights.waterlevel =
            data?.preferences?.chartHeights?.waterlevel || userSettings.preferences.chartHeights.waterlevel;
        userSettings.preferences.chartHeights.wind =
            data?.preferences?.chartHeights?.wind || userSettings.preferences.chartHeights.wind;
        userSettings.preferences.chartHeights.noise =
            data?.preferences?.chartHeights?.noise || userSettings.preferences.chartHeights.noise;
        userSettings.preferences.statusPageRefreshEnabled =
            data?.preferences?.statusPageRefreshEnabled || userSettings.preferences.statusPageRefreshEnabled;
        userSettings.preferences.floorPlanSettings.displayMode =
            data?.preferences?.floorPlanSettings?.displayMode || userSettings.preferences.floorPlanSettings.displayMode;
        userSettings.preferences.floorPlanSettings.eventType =
            data?.preferences?.floorPlanSettings?.eventType || userSettings.preferences.floorPlanSettings.eventType;
        userSettings.preferences.floorPlanSettings.selectedHardware =
            data?.preferences?.floorPlanSettings?.selectedHardware ||
                userSettings.preferences.floorPlanSettings.selectedHardware;
        userSettings.preferences.csvFormatLocale =
            data?.preferences?.csvFormatLocale || userSettings.preferences.csvFormatLocale;
        userSettings.preferences.dashboardLayout =
            data?.preferences?.dashboardLayout || userSettings.preferences.dashboardLayout;
        userSettings.notifications.pause.msgDismissedAt =
            data?.notifications?.pause?.msgDismissedAt || userSettings.notifications.pause.msgDismissedAt;
        userSettings.notifications.pause.until =
            data?.notifications?.pause?.until || userSettings.notifications.pause.until;
        userSettings.customSettings = data?.customSettings || userSettings.customSettings;
        userSettings.userRating.isSubmitted = data?.userRating?.isSubmitted || userSettings.userRating.isSubmitted;
        userSettings.userRating.lastShownTimestamp =
            data?.userRating?.lastShownTimestamp || userSettings.userRating.lastShownTimestamp;
        userSettings.userRating.firstLoginTimestamp =
            data?.userRating?.firstLoginTimestamp || userSettings.userRating.firstLoginTimestamp;
        if (data?.events) {
            Object.keys(userSettings.events.units).forEach((unitKey) => {
                if (data.events.units[unitKey] != null) {
                    userSettings.events.units[unitKey] = data.events.units[unitKey];
                }
            });
        }
        return userSettings;
    }
    static parseDatetime(data) {
        try {
            let parsed = {
                format: 'DD.MM.YYYY HH:mm:ss',
                dateFormat: 'DD.MM.YYYY',
                timezone: 'Europe/Bratislava',
                clockFormat: '24h',
                tzInFormat: 'false'
            };
            if (!data)
                return parsed;
            if (data.clockFormat && data.dateFormat && data.tzInFormat)
                return data;
            parsed.format = data.format.trim();
            data.format = data.format.trim();
            let formatParts = data.format.split(' ');
            let actualLastPart = formatParts.pop();
            if (data.tzInFormat == undefined) {
                if (actualLastPart == 'zz') {
                    parsed.tzInFormat = 'true';
                    actualLastPart = formatParts.pop();
                }
            }
            else {
                parsed.tzInFormat = data.tzInFormat;
            }
            if (data.clockFormat == undefined) {
                if (actualLastPart == 'A') {
                    parsed.clockFormat = '12h';
                    actualLastPart = formatParts.pop();
                }
            }
            else {
                parsed.clockFormat = data.clockFormat;
            }
            if (data.dateFormat)
                parsed.dateFormat = data.dateFormat;
            if (data.timezone)
                parsed.timezone = data.timezone;
            return parsed;
        }
        catch (e) {
            return data;
        }
    }
}
export var AppTheme;
(function (AppTheme) {
    AppTheme["LIGHT"] = "light";
    AppTheme["DARK"] = "dark";
})(AppTheme || (AppTheme = {}));
